import CONTACTS from 'constants/Contacts'
import * as C from 'constants/ApiUrls'
import { mappings } from './Response'
import Request from './Request'

export const apiUAccount = async () => {
  let response
  try {
    response = await Request.get({ url: C.URL_U_ACCOUNT })
  } catch (error) {
    return Promise.reject(error)
  }

  return response.data
}

export const apiUDepartments = async () => {
  let response
  try {
    response = await Request.get({ url: C.URL_U_DEPARTMENTS })
  } catch (error) {
    return Promise.reject(error)
  }
  return mappings[CONTACTS.names.department](response.data)
}

export const apiUCallQueues = async () => {
  let response
  try {
    response = await Request.get({ url: C.URL_U_CALL_QUEUES })
  } catch (error) {
    return Promise.reject(error)
  }

  return mappings[CONTACTS.names.callQueues](response.items)
}

export const apiUWelcomeMenus = async () => {
  let response
  try {
    response = await Request.get({ url: C.URL_U_WELCOME_MENUS })
  } catch (error) {
    return Promise.reject(error)
  }

  return mappings[CONTACTS.names.welcomeMenu](response.data)
}

export const apiURingGroups = async () => {
  let response
  try {
    response = await Request.get({ url: C.URL_U_RING_GROUPS })
  } catch (error) {
    return Promise.reject(error)
  }

  return mappings[CONTACTS.names.ringGroup](response.data)
}

export const apiUCNDInfo = async () => {
  let response
  try {
    response = await Request.get({ url: C.URL_U_CND_INFO })
  } catch (error) {
    return Promise.reject(error)
  }

  const { displayName: name, setting: number, isActive } = response.data

  if (!isActive || number === '0') return {}

  return { name, number }
}

export const apiUGetCND = async () => {
  let response
  try {
    response = await Request.get({ url: C.URL_U_CND })
  } catch (error) {
    return Promise.reject(error)
  }
  const { lineData } = response.data

  return { lineData }
}

export const apiUUpdateCND = async (active, objectId, objectType, setting) => {
  const data = JSON.stringify({
    id: 'cnd',
    isActive: active,
    isSubscribed: true,
    objectId,
    type: objectType,
    setting,
  })

  try {
    await Request.put({ url: C.URL_U_CND, data })
  } catch (error) {
    return Promise.reject(error)
  }

  return Promise.resolve()
}

export const apiUWebRTCInfo = async () => {
  let response
  try {
    response = await Request.get({ url: C.URL_U_WEBRTC })
  } catch (error) {
    return Promise.reject(error)
  }

  const data = response.data || {}
  return {
    username: data.guid,
    ...data,
  }
}

export const apiPContactsList = (syncToken) => {
  const params = new URLSearchParams()

  params.set('limit', '-1')
  params.set('request_sync_token', 'true')

  if (syncToken) {
    params.set('sync_token', syncToken)
  }

  return Request.get({
    url: `${C.URL_U_CONTACTS_LIST}?${params.toString()}`,
  })
}
